import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { resetPassword } from 'aws-amplify/auth';
import Notification from './Notification';
import Spinner from './Spinner';
import '../styles/Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState({ show: false, message: '', type: '' });
  const [emailSent, setEmailSent] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await resetPassword({ username: email });
      
      setNotification({
        show: true,
        message: 'Password reset email sent! Check your inbox.',
        type: 'success'
      });
      
      setEmailSent(true);
      
      // Redirect to reset password confirmation page after a delay
      setTimeout(() => {
        navigate('/reset-password', { state: { email } });
      }, 3000);
      
    } catch (error) {
      console.error('Forgot password error:', error);
      setNotification({
        show: true,
        message: error.message || 'Failed to send reset email',
        type: 'error'
      });
    } finally {
      setLoading(false);
      setTimeout(() => setNotification({ show: false, message: '', type: '' }), 3000);
    }
  };

  return (
    <div className="auth-container">
      {notification.show && (
        <Notification 
          message={notification.message} 
          type={notification.type} 
        />
      )}
      
      <div className="auth-card">
        <h2>Forgot Password</h2>
        
        {!emailSent ? (
          <>
            <p className="auth-description">
              Enter your email address and we'll send you a link to reset your password.
            </p>
            
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="form-control"
                  placeholder="Enter your email address"
                />
              </div>
              
              <button 
                type="submit" 
                className="btn-primary auth-btn"
                disabled={loading}
              >
                {loading ? <Spinner size="small" message="" /> : 'Send Reset Email'}
              </button>
            </form>
          </>
        ) : (
          <div className="success-message">
            <h3>Email Sent!</h3>
            <p>We've sent a password reset link to <strong>{email}</strong></p>
            <p>Please check your inbox and follow the instructions to reset your password.</p>
          </div>
        )}
        
        <div className="auth-links">
          <p className="auth-link">
            Remember your password? <Link to="/login">Back to Login</Link>
          </p>
          <p className="auth-link">
            Don't have an account? <Link to="/signup">Sign up</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;